import type { FaireBrandEntity } from "../../entity_types/brand";

// Chocolate Brand — real Faire brand (b_d7zqrbdq), shown under an anonymized
// name. Identity metadata from ANALYTICS.CANONICAL.BRANDS; backs the
// ads-manager-2 "Chocolate Brand" real-brand variant (advertiser
// -2425147271178345382). The token and advertiser id are kept so the Snowflake
// refresh path in snowflakeQueries.ts still resolves; the country of origin is
// dropped from the description because it names the brand on its own.
export const b_d7zqrbdq: FaireBrandEntity = {
  token: "b_d7zqrbdq",
  type: "brand",
  name: "Chocolate Brand",
  description: "Organic bean-to-bar and hand-scooped chocolate.",
  location: "Southeast, USA",
  isTopShop: true,
  tags: ["food-drink", "chocolate", "organic"],
  meta: {
    source: "snowflake",
    importedAt: "2026-08-30T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
